import {
  Button,
  CascaderField,
  Col,
  Form,
  Row,
  Space,
  SubmitButton,
  TextInputField,
} from '@/components';
import { useOrganizationOptionsRecursive } from '@/features/tenant-manager/organization/_hooks/organization';
import type { WorkflowTemplateSearchFormSchema } from '@/features/workflow/models/template';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type FormValues = z.infer<typeof WorkflowTemplateSearchFormSchema>;

type Props = {
  resetFormValues: FormValues;
  onSearch: (values: FormValues) => void;
};

export const WorkflowTemplateSearchForm: FC<Props> = ({
  resetFormValues,
  onSearch,
}) => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
    reset,
    handleSubmit,
  } = useFormContext<FormValues>();

  const organizationsOptions = useOrganizationOptionsRecursive();

  return (
    <Form
      leavePageAlertCondition={null}
      layout="vertical"
      onFinish={handleSubmit(onSearch)}
    >
      <Row gutter={[16, 0]}>
        <Col span={6}>
          <TextInputField
            name="q"
            label={t('workflow.template-name')}
            control={control}
            errors={errors}
          />
        </Col>
        <Col span={6}>
          <CascaderField
            name="nestedOrganizationIds"
            label={t('workflow.organization')}
            control={control}
            options={organizationsOptions.data}
            multiple
            errors={errors}
          />
        </Col>
      </Row>
      <Space>
        <Button
          htmlType="button"
          type="default"
          onClick={() => {
            reset(resetFormValues);
          }}
        >
          {t('search-clear')}
        </Button>
        <SubmitButton text={t('search-by')} />
      </Space>
    </Form>
  );
};
